import { httpClient } from '../lib/http-client';
import { BuscaFavorita } from '../types';

/**
 * Service para gerenciamento de buscas favoritas
 */
export class BuscasFavoritasService {
  static async getBuscasFavoritas(): Promise<BuscaFavorita[]> {
    return httpClient.get<BuscaFavorita[]>('/api/buscas-favoritas');
  }

  static async getBuscaFavorita(id: number): Promise<BuscaFavorita> {
    return httpClient.get<BuscaFavorita>(`/api/buscas-favoritas/${id}`);
  }

  static async createBuscaFavorita(data: Partial<BuscaFavorita>): Promise<BuscaFavorita> {
    return httpClient.post<BuscaFavorita>('/api/buscas-favoritas', data);
  }

  static async updateBuscaFavorita(id: number, data: Partial<BuscaFavorita>): Promise<BuscaFavorita> {
    return httpClient.put<BuscaFavorita>(`/api/buscas-favoritas/${id}`, data);
  }

  static async deleteBuscaFavorita(id: number): Promise<{ success: boolean; message?: string }> {
    return httpClient.delete<{ success: boolean; message?: string }>(`/api/buscas-favoritas/${id}`);
  }
}

